(() => {

    // ---------- State ----------
    const state = {
        wallCm: 400,
        unit: 'cm',
        pxPerCm_display: 1, // On-screen scale
        pxPerCm_natural: 1, // Full-resolution export scale
        bgLoaded: false,
        logoLoaded: false,
        logo: {
            leftPx: 0, topPx: 0, widthPx: 0, heightPx: 0,
            leftRel: 0, topRel: 0, widthRel: 0, heightRel: 0,
            aspect: 1,
            baseAspect: 1,
            initialWidthRel: 0,
            initialHeightRel: 0,
        },
        dragging: false,
        resizing: false,
        resizeDir: null,
        aspectLocked: true,
        cropper: null,
        cropBlobUrl: null,
        bgImage: new Image(),
        logoSource: new Image(),
    };

    // ---------- Elements ----------
    const bg = document.getElementById('bg');
    const stage = document.getElementById('stage');
    const wallWidthInput = document.getElementById('wallWidth');
    const unitSelect = document.getElementById('unitSelect');
    const infoWall = document.getElementById('infoWall');
    const infoLogo = document.getElementById('infoLogo');
    const infoScale = document.getElementById('infoScale');
    const logoInput = document.getElementById('logoInput');
    const bgInput = document.getElementById('bgInput');
    const aspectLock = document.getElementById('aspectLock');
    const aspectState = document.getElementById('aspectState');
    const resetLogoBtn = document.getElementById('resetLogoBtn');
    const resetSizeBtn = document.getElementById('resetSizeBtn');
    const downloadBtn = document.getElementById('downloadBtn');

    // New input elements for manual sizing
    const logoWidthCmInput = document.getElementById('logoWidthCm');
    const logoHeightCmInput = document.getElementById('logoHeightCm');

    const logoBox = document.getElementById('logoBox');
    const logoImage = document.getElementById('logoImage');

    const cropperModalEl = document.getElementById('cropperModal');
    const cropperImage = document.getElementById('cropperImage');
    const cropConfirm = document.getElementById('cropConfirm');
    const cropperModal = new bootstrap.Modal(cropperModalEl);

    const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

    function showToast(message, variant = 'primary') {
        const el = document.createElement('div');
        el.className = `toast align-items-center text-bg-${variant} border-0`;
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        el.innerHTML = `
        <div class="d-flex">
          <div class="toast-body">${message}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>`;
        document.getElementById('toasts').appendChild(el);
        const t = new bootstrap.Toast(el, { delay: 3500 });
        t.show();
        el.addEventListener('hidden.bs.toast', () => el.remove());
    }

    function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

    // conversions
    function toCm(val, unit) {
        switch (unit) {
            case 'cm': return val;
            case 'm': return val * 100;
            case 'in': return val * 2.54;
            case 'ft': return val * 30.48;
            default: return val;
        }
    }
    function fromCm(cm, unit) {
        switch (unit) {
            case 'cm': return cm;
            case 'm': return cm / 100;
            case 'in': return cm / 2.54;
            case 'ft': return cm / 30.48;
            default: return cm;
        }
    }
    function fmt(n, digits = 1) { return Number(n).toFixed(digits); }

    function recomputeScale() {
        if (!state.bgLoaded) return;
        const dispW = bg.clientWidth;
        const wallCm = state.wallCm > 0 ? state.wallCm : 1;
        state.pxPerCm_display = dispW / wallCm;
        const naturalW = state.bgImage.naturalWidth || 1;
        state.pxPerCm_natural = naturalW / wallCm;
        updateInfoBar();
        applyLogoFromRel();
    }

    function updateInfoBar() {
        const wallVal = fromCm(state.wallCm, state.unit);
        infoWall.textContent = `${fmt(wallVal)} ${state.unit}`;
        infoScale.textContent = `${fmt(state.pxPerCm_display, 2)} px/cm (display)`;
        if (state.logoLoaded) {
            const wCm = state.logo.widthPx / state.pxPerCm_display;
            const hCm = state.logo.heightPx / state.pxPerCm_display;
            infoLogo.textContent = `${fmt(wCm)} cm × ${fmt(hCm)} cm`;

            // NEW: Update the manual input fields
            logoWidthCmInput.value = Math.trunc(fmt(wCm));
            logoHeightCmInput.value = Math.trunc(fmt(hCm));
            logoWidthCmInput.disabled = false;
            logoHeightCmInput.disabled = false;

        } else {
            infoLogo.textContent = '—';
            // NEW: Disable manual input fields when no logo is loaded
            logoWidthCmInput.value = '';
            logoHeightCmInput.value = '';
            logoWidthCmInput.disabled = true;
            logoHeightCmInput.disabled = true;
        }
        // Let the CRO layer react (enable/disable Save/Share, refresh quote size, etc.)
        document.dispatchEvent(new CustomEvent('mockup:updated'));
    }

    function updateLogoRel() {
        const sw = bg.clientWidth || stage.clientWidth;
        const sh = bg.clientHeight || stage.clientHeight;
        state.logo.leftRel = state.logo.leftPx / sw;
        state.logo.topRel = state.logo.topPx / sh;
        state.logo.widthRel = state.logo.widthPx / sw;
        state.logo.heightRel = state.logo.heightPx / sh;
    }

    function applyLogoFromRel() {
        if (!state.logoLoaded) return;
        const sw = bg.clientWidth || stage.clientWidth;
        const sh = bg.clientHeight || stage.clientHeight;
        state.logo.leftPx = state.logo.leftRel * sw;
        state.logo.topPx = state.logo.topRel * sh;
        state.logo.widthPx = state.logo.widthRel * sw;
        state.logo.heightPx = state.logo.heightRel * sh;
        positionLogoBox();
        updateInfoBar();
    }

    function positionLogoBox() {
        logoBox.style.left = state.logo.leftPx + 'px';
        logoBox.style.top = state.logo.topPx + 'px';
        logoBox.style.width = state.logo.widthPx + 'px';
        logoBox.style.height = state.logo.heightPx + 'px';
    }

    function centerLogo() {
        if (!state.logoLoaded) return;
        const sw = bg.clientWidth || stage.clientWidth;
        const sh = bg.clientHeight || stage.clientHeight;
        const w = Math.min(sw * 0.3, sw);
        const h = w / (state.logo.baseAspect || state.logo.aspect || 1);
        const left = (sw - w) / 2;
        const top = (sh - h) / 2;
        state.logo.widthPx = w; state.logo.heightPx = h; state.logo.leftPx = left; state.logo.topPx = top;
        updateLogoRel();
        state.logo.initialWidthRel = state.logo.widthRel;
        state.logo.initialHeightRel = state.logo.heightRel;
        positionLogoBox();
        updateInfoBar();
    }

    // ---------- Background handling ----------
    function setBackgroundSrc(src, defaultWallCm = null) {
        bg.crossOrigin = 'anonymous';
        bg.onload = () => {
            state.bgLoaded = true;
            state.bgImage.src = bg.src;
            if (defaultWallCm) {
                state.wallCm = defaultWallCm;
                wallWidthInput.value = fmt(fromCm(state.wallCm, state.unit));
            }
            state.bgImage.onload = () => {
                recomputeScale();
                if (state.logoLoaded) applyLogoFromRel();
            }
            updateInfoBar();
        };
        bg.onerror = () => showToast('Failed to load background image. Try another file/URL.', 'danger');
        bg.src = src;
    }

    $$('.thumb').forEach(img => {
        img.addEventListener('click', () => {
            $$('.thumb').forEach(t => t.classList.remove('active'));
            img.classList.add('active');
            const src = img.getAttribute('data-src');
            const wall = Number(img.getAttribute('data-wall-cm')) || 400;
            setBackgroundSrc(src, wall);
        });
    });

    bgInput.addEventListener('change', (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (/\.(ai|eps)$/i.test(file.name)) {
            showToast('AI/EPS are not supported in browsers. Convert to SVG or PNG first.', 'warning');
            e.target.value = '';
            return;
        }
        const url = URL.createObjectURL(file);
        setBackgroundSrc(url);
        $$('.thumb').forEach(t => t.classList.remove('active'));
    });

    // ---------- Wall width + unit ----------
    unitSelect.addEventListener('change', () => {
        state.unit = unitSelect.value;
        wallWidthInput.value = fmt(fromCm(state.wallCm, state.unit));
        recomputeScale();
    });

    wallWidthInput.addEventListener('input', () => {
        const v = parseFloat(wallWidthInput.value);
        if (!isFinite(v) || v <= 0) return;
        state.wallCm = toCm(v, state.unit);
        recomputeScale();
    });

    // NEW: Manual input event listeners
    logoWidthCmInput.addEventListener('input', (e) => {
        if (!state.logoLoaded) return;
        const newWidthCm = parseFloat(e.target.value);
        if (!isFinite(newWidthCm) || newWidthCm <= 0) return;

        const newWidthPx = newWidthCm * state.pxPerCm_display;
        const newHeightPx = newWidthPx / (state.logo.baseAspect || state.logo.aspect || 1);

        // Update state and position
        state.logo.widthPx = newWidthPx;
        state.logo.heightPx = newHeightPx;
        positionLogoBox();
        updateLogoRel();

        // Also update the height input field
        const newHeightCm = newHeightPx / state.pxPerCm_display;
        logoHeightCmInput.value = Math.trunc(fmt(newHeightCm));
        updateInfoBar();
    });

    logoHeightCmInput.addEventListener('input', (e) => {
        if (!state.logoLoaded) return;
        const newHeightCm = parseFloat(e.target.value);
        if (!isFinite(newHeightCm) || newHeightCm <= 0) return;

        const newHeightPx = newHeightCm * state.pxPerCm_display;
        const newWidthPx = newHeightPx * (state.logo.baseAspect || state.logo.aspect || 1);

        // Update state and position
        state.logo.widthPx = newWidthPx;
        state.logo.heightPx = newHeightPx;
        positionLogoBox();
        updateLogoRel();

        // Also update the width input field
        const newWidthCm = newWidthPx / state.pxPerCm_display;
        logoWidthCmInput.value = Math.trunc(fmt(newWidthCm));
        updateInfoBar();
    });


    let pendingDataUrl = null;
    let initHandlerBound = false;

    logoInput.addEventListener('change', async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        if (/\.(ai|eps)$/i.test(file.name)) {
            showToast('AI/EPS cannot render natively. Please convert to SVG or PNG, then upload.', 'warning');
            e.target.value = '';
            return;
        }

        const isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name);

        try {
            const dataUrl = await fileToDataURL(file, isSvg);
            pendingDataUrl = dataUrl;
            cropperImage.src = dataUrl;
            cropperModal.show();
            if (!initHandlerBound) {
                initHandlerBound = true;
                cropperModalEl.addEventListener('shown.bs.modal', () => {
                    const init = () => {
                        if (state.cropper) state.cropper.destroy();
                        state.cropper = new Cropper(cropperImage, {
                            viewMode: 1,
                            autoCropArea: 1,
                            responsive: true,
                            checkCrossOrigin: false,
                            background: false,
                        });
                    };
                    if (cropperImage.complete) {
                        init();
                    } else {
                        cropperImage.onload = () => init();
                    }
                });
                cropperModalEl.addEventListener('hidden.bs.modal', () => {
                    if (state.cropper) {
                        state.cropper.destroy();
                        state.cropper = null;
                    }
                    pendingDataUrl = null;
                });
            }
        } catch (err) {
            console.error(err);
            showToast('Could not open image. Please try a different file.', 'danger');
        }
    });

    cropConfirm.addEventListener('click', () => {
        if (!state.cropper) return;
        const MAX = 3000;
        const canvas = state.cropper.getCroppedCanvas({ maxWidth: MAX, maxHeight: MAX });
        canvas.toBlob(blob => {
            if (!blob) { showToast('Crop failed. Try again.', 'danger'); return; }
            const url = URL.createObjectURL(blob);
            state.logoSource.onload = () => {
                state.logo.aspect = state.logoSource.width / state.logoSource.height;
                state.logo.baseAspect = state.logo.aspect;
                logoImage.src = url;
                logoBox.classList.remove('d-none');
                state.logoLoaded = true;
                centerLogo();
                cropperModal.hide();
            };
            state.logoSource.src = url;
        }, 'image/png', 1);
    });

    function fileToDataURL(file, isSvg) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(reader.error);
            if (isSvg) {
                reader.onload = () => {
                    try {
                        const svgText = reader.result;
                        const svgBlob = new Blob([svgText], { type: 'image/svg+xml' });
                        const svgUrl = URL.createObjectURL(svgBlob);
                        const img = new Image();
                        img.onload = () => {
                            const max = 3000;
                            const scale = Math.min(1, max / Math.max(img.naturalWidth || 1500, img.naturalHeight || 1500));
                            const w = Math.max(1, Math.round((img.naturalWidth || 1500) * scale));
                            const h = Math.max(1, Math.round((img.naturalHeight || 1500) * scale));
                            const c = document.createElement('canvas'); c.width = w; c.height = h;
                            const ctx = c.getContext('2d');
                            ctx.drawImage(img, 0, 0, w, h);
                            URL.revokeObjectURL(svgUrl);
                            resolve(c.toDataURL('image/png'));
                        };
                        img.onerror = () => { URL.revokeObjectURL(svgUrl); reject(new Error('SVG failed to load')); };
                        img.src = svgUrl;
                    } catch (err) { reject(err); }
                };
                reader.readAsText(file);
            } else {
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(file);
            }
        });
    }

    // ---------- Drag & Resize ----------
    const dragOverlay = logoBox.querySelector('.drag-overlay');
    const handles = $$('.handle', logoBox);
    let startX = 0, startY = 0, startLeft = 0, startTop = 0, startW = 0, startH = 0, startPointerId = null;

    function beginInteraction() { logoBox.classList.add('active'); }
    function endInteraction() { logoBox.classList.remove('active'); updateLogoRel(); updateInfoBar(); }

    // Dragging
    dragOverlay.addEventListener('pointerdown', (e) => {
        if (!state.logoLoaded) return;
        state.dragging = true;
        beginInteraction();
        startPointerId = e.pointerId;
        dragOverlay.setPointerCapture(startPointerId);
        startX = e.clientX; startY = e.clientY;
        startLeft = state.logo.leftPx; startTop = state.logo.topPx;
        e.preventDefault();
    });
    dragOverlay.addEventListener('pointermove', (e) => {
        if (!state.dragging) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        const sw = bg.clientWidth, sh = bg.clientHeight;
        let newLeft = startLeft + dx;
        let newTop = startTop + dy;
        newLeft = clamp(newLeft, 0, sw - state.logo.widthPx);
        newTop = clamp(newTop, 0, sh - state.logo.heightPx);
        state.logo.leftPx = newLeft; state.logo.topPx = newTop;
        positionLogoBox();
        updateInfoBar();
    });
    const endDrag = () => { if (state.dragging) { state.dragging = false; if (startPointerId != null) { try { dragOverlay.releasePointerCapture(startPointerId); } catch { } startPointerId = null; } endInteraction(); } };
    dragOverlay.addEventListener('pointerup', endDrag);
    dragOverlay.addEventListener('pointercancel', endDrag);

    // Resizing
    handles.forEach(h => {
        h.addEventListener('pointerdown', (e) => {
            if (!state.logoLoaded) return;
            state.resizing = true; state.resizeDir = h.dataset.dir;
            beginInteraction();
            startPointerId = e.pointerId;
            h.setPointerCapture(startPointerId);
            startX = e.clientX; startY = e.clientY;
            startLeft = state.logo.leftPx; startTop = state.logo.topPx;
            startW = state.logo.widthPx; startH = state.logo.heightPx;
            e.preventDefault();
        });
        h.addEventListener('pointermove', (e) => {
            if (!state.resizing) return;
            const dx = e.clientX - startX; const dy = e.clientY - startY;
            const sw = bg.clientWidth, sh = bg.clientHeight;
            let left = startLeft, top = startTop, w = startW, hgt = startH;
            const ar = state.aspectLocked ? (state.logo.baseAspect || 1) : (state.logo.aspect || (w / hgt) || 1);
            const dir = state.resizeDir;
            const minSize = 20;

            function applyW(newW) {
                newW = Math.max(minSize, newW);
                let newH = state.aspectLocked ? newW / ar : hgt + (dir.includes('n') || dir.includes('s') ? dy : 0);
                if (state.aspectLocked) {
                    if (dir.includes('n')) top = startTop + (hgt - newH);
                    if (dir.includes('w')) left = startLeft + (w - newW);
                }
                w = newW; hgt = newH;
            }

            if (dir === 'se') {
                if (state.aspectLocked) { applyW(startW + dx); }
                else { w = startW + dx; hgt = startH + dy; }
            } else if (dir === 'ne') {
                if (state.aspectLocked) { applyW(startW + dx); top = startTop + (startH - hgt); }
                else { w = startW + dx; hgt = startH - dy; top = startTop + dy; }
            } else if (dir === 'sw') {
                if (state.aspectLocked) { applyW(startW - dx); left = startLeft + (startW - w); }
                else { w = startW - dx; hgt = startH + dy; left = startLeft + dx; }
            } else if (dir === 'nw') {
                if (state.aspectLocked) { applyW(startW - dx); left = startLeft + (startW - w); top = startTop + (startH - hgt); }
                else { w = startW - dx; hgt = startH - dy; left = startLeft + dx; top = startTop + dy; }
            }

            // Clamp within stage
            w = clamp(w, minSize, sw);
            hgt = clamp(hgt, minSize, sh);
            left = clamp(left, 0, sw - w);
            top = clamp(top, 0, sh - hgt);

            state.logo.leftPx = left; state.logo.topPx = top; state.logo.widthPx = w; state.logo.heightPx = hgt;
            positionLogoBox();
            updateInfoBar();
        });
        const endResize = () => { if (state.resizing) { state.resizing = false; if (startPointerId != null) { try { h.releasePointerCapture(startPointerId); } catch { } startPointerId = null; } if (!state.aspectLocked) { state.logo.aspect = state.logo.widthPx / state.logo.heightPx; } endInteraction(); } };
        h.addEventListener('pointerup', endResize);
        h.addEventListener('pointercancel', endResize);
    });

    // Aspect toggle
    aspectLock.addEventListener('change', () => {
        state.aspectLocked = aspectLock.checked;
        aspectState.textContent = state.aspectLocked ? 'Locked' : 'Unlocked';
        if (state.logoLoaded && state.aspectLocked) {
            const ar = state.logo.baseAspect || 1;
            const sw = bg.clientWidth || stage.clientWidth;
            const sh = bg.clientHeight || stage.clientHeight;
            let w = state.logo.widthPx;
            let h = w / ar;
            if (h > sh) { h = sh; w = h * ar; }
            state.logo.widthPx = w; state.logo.heightPx = h;
            state.logo.topPx = clamp(state.logo.topPx, 0, sh - h);
            state.logo.leftPx = clamp(state.logo.leftPx, 0, sw - w);
            positionLogoBox(); updateLogoRel(); updateInfoBar();
        }
    });

    resetLogoBtn.addEventListener('click', () => {
        logoInput.value = "";
        state.logoLoaded = false;
        logoBox.classList.add('d-none');
        logoImage.removeAttribute('src');
        infoLogo.textContent = '—';
        // NEW: Also clear and disable the manual inputs
        logoWidthCmInput.value = '';
        logoHeightCmInput.value = '';
        logoWidthCmInput.disabled = true;
        logoHeightCmInput.disabled = true;
    });

    resetSizeBtn.addEventListener('click', () => {
        if (!state.logoLoaded) return;
        const sw = bg.clientWidth || stage.clientWidth;
        const sh = bg.clientHeight || stage.clientHeight;
        const cx = state.logo.leftPx + state.logo.widthPx / 2;
        const cy = state.logo.topPx + state.logo.heightPx / 2;
        state.logo.widthRel = state.logo.initialWidthRel || state.logo.widthRel;
        state.logo.heightRel = state.logo.initialHeightRel || state.logo.heightRel;
        state.logo.widthPx = state.logo.widthRel * sw;
        state.logo.heightPx = state.logo.heightRel * sh;
        state.logo.leftPx = clamp(cx - state.logo.widthPx / 2, 0, sw - state.logo.widthPx);
        state.logo.topPx = clamp(cy - state.logo.heightPx / 2, 0, sh - state.logo.heightPx);
        updateLogoRel(); positionLogoBox(); updateInfoBar();
    });

    // ---------- Composite export (shared by Download + the CRO save/share layer) ----------
    // Builds the full-resolution composited canvas (background + scaled logo).
    // Returns the canvas, or null if the background isn't ready. Unchanged maths
    // from the original download handler — just extracted so it can be reused.
    async function buildCompositeCanvas() {
        if (!state.bgLoaded) return null;
        const W = state.bgImage.naturalWidth || bg.naturalWidth || bg.clientWidth;
        const H = state.bgImage.naturalHeight || bg.naturalHeight || bg.clientHeight;
        if (!W || !H) return null;
        const canvas = document.createElement('canvas'); canvas.width = W; canvas.height = H;
        const ctx = canvas.getContext('2d');
        await drawImageFit(ctx, state.bgImage, 0, 0, W, H);
        if (state.logoLoaded && state.logoSource && state.logoSource.width) {
            const lw_cm = state.logo.widthPx / state.pxPerCm_display;
            const lh_cm = state.logo.heightPx / state.pxPerCm_display;

            const lw = lw_cm * state.pxPerCm_natural;
            const lh = lh_cm * state.pxPerCm_natural;

            const bg_disp_w = bg.clientWidth;
            const bg_disp_h = bg.clientHeight;
            const logo_disp_center_x = state.logo.leftPx + state.logo.widthPx / 2;
            const logo_disp_center_y = state.logo.topPx + state.logo.heightPx / 2;

            const logo_natural_center_x = (logo_disp_center_x / bg_disp_w) * W;
            const logo_natural_center_y = (logo_disp_center_y / bg_disp_h) * H;

            const lx = logo_natural_center_x - lw / 2;
            const ly = logo_natural_center_y - lh / 2;

            ctx.drawImage(state.logoSource, lx, ly, lw, lh);
        }
        return canvas;
    }

    // ---------- Download ----------
    downloadBtn.addEventListener('click', async () => {
        if (!state.bgLoaded) { showToast('Load a background first.', 'warning'); return; }
        try {
            const canvas = await buildCompositeCanvas();
            if (!canvas) { showToast('Background not ready to export.', 'danger'); return; }
            // Download via a Blob URL (not a data: URL) — data: URLs fail the
            // download in Chrome for larger images ("check your internet connection").
            canvas.toBlob(function (blob) {
                if (!blob) { showToast('Could not build the image. Please try again.', 'danger'); return; }
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a'); a.href = url; a.download = 'logo-mockup.png';
                document.body.appendChild(a); a.click(); a.remove();
                setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
            }, 'image/png');
        } catch (err) {
            console.error(err);
            showToast('Export blocked by image CORS. Upload your own background instead of a remote image, then try again.', 'warning');
        }
    });

    // ---------- Public API for the CRO / lead-capture layer (mockup-tool-cro.js) ----------
    // Deliberately small surface so the engine stays self-contained.
    window.MockupTool = {
        hasBackground: () => state.bgLoaded,
        hasLogo: () => state.logoLoaded,
        // Human-readable snapshot of the current mockup (used for Klaviyo props + quote deep-link)
        getSummary: () => {
            const summary = { wall_cm: Math.round(state.wallCm), unit: state.unit };
            if (state.logoLoaded && state.pxPerCm_display) {
                summary.logo_w_cm = Math.round(state.logo.widthPx / state.pxPerCm_display);
                summary.logo_h_cm = Math.round(state.logo.heightPx / state.pxPerCm_display);
            }
            const activeThumb = document.querySelector('.thumb.active');
            summary.background = activeThumb ? (activeThumb.getAttribute('alt') || 'Preset') : 'Custom upload';
            return summary;
        },
        // Returns a PNG Blob of the composited mockup (or null). Reused for upload/share/email.
        getCompositeBlob: async (type = 'image/png', quality = 0.92) => {
            const canvas = await buildCompositeCanvas();
            if (!canvas) return null;
            return await new Promise((res) => canvas.toBlob(res, type, quality));
        },
        getCompositeDataURL: async () => {
            const canvas = await buildCompositeCanvas();
            return canvas ? canvas.toDataURL('image/png') : null;
        },
    };
    document.dispatchEvent(new CustomEvent('mockup:ready'));

    function drawImageFit(ctx, img, x, y, w, h) {
        return new Promise((resolve, reject) => {
            if (!img.complete) { img.onload = () => { ctx.drawImage(img, x, y, w, h); resolve(); }; img.onerror = reject; }
            else { ctx.drawImage(img, x, y, w, h); resolve(); }
        });
    }

    bg.addEventListener('load', () => {
        state.bgImage = new Image();
        state.bgImage.crossOrigin = 'anonymous';
        state.bgImage.src = bg.currentSrc || bg.src;
    });

    $$("[data-bs-toggle='tooltip']").forEach(el => new bootstrap.Tooltip(el));

    const ro = new ResizeObserver(() => recomputeScale());
    ro.observe(stage);
    ro.observe(bg);

    (function init() {
        document.getElementById('preset1').click();
        wallWidthInput.value = fmt(fromCm(state.wallCm, state.unit));
        recomputeScale();
    })();

    document.getElementById("colorInput").addEventListener("input", function () {
        bg.style.backgroundColor = this.value;
    });

})();